import React from 'react';
import { ARCHIVE_STATUS_LABELS } from '../constants';

const STATUS_STYLES: Record<string, string> = {
  published: 'bg-green-900/50 text-green-200 border-green-700',
  unpublished: 'bg-secondary-700 text-secondary-200 border-secondary-600',
  removed: 'bg-red-900/50 text-red-200 border-red-800',
};

interface ArchiveStatusBadgeProps {
  status?: string | null;
}

const ArchiveStatusBadge: React.FC<ArchiveStatusBadgeProps> = ({ status }) => {
  if (!status) return <span className="text-secondary-500 text-sm">—</span>;
  const key = status.toLowerCase();
  const style = STATUS_STYLES[key] ?? STATUS_STYLES.unpublished;
  const label = ARCHIVE_STATUS_LABELS[key] ?? status.replace(/_/g, ' ');
  return (
    <span
      className={`inline-flex rounded-full border px-2 py-0.5 text-xs font-medium capitalize ${style}`}
    >
      {label}
    </span>
  );
};

export default ArchiveStatusBadge;
